import React, { useEffect, useState } from "react";
import MainPlayer from "../mainPlayer";
import cx from "classnames";
import _ from "lodash";
import { createGlobalStyle } from "styled-components";
import FlipModal from "../flipModal";
import background from "../flipModal/background.png";
import arrow from "../flipModal/arrow.png";
import Masonry from "react-masonry-css";
let interval = null;
const LeftCard = (props) => {
  const { text, flipped = false, goldCardText, status } = props;
  const que = text && text.replace(/\[BLANK]/g, "________");

  return (
    <div className={cx("left-card", { flipped })}>
      {status === "PrePlay" ? (
        goldCardText &&
        goldCardText.map((item) => {
          return <p>{item}</p>;
        })
      ) : (
        <>
          <span className="hash-tag-code">#DoneWith2020</span>
          <p>{que}</p>
        </>
      )}
    </div>
  );
};
const RightCard = (props) => {
  const { text, flipped, status, que } = props;
  return (
    <div className={cx("right-card", { flipped, notFlipped: !flipped })}>
      {(status === "Playing" ||
        status === "Reading" ||
        status === "Evaluating") && (
        <>
          {flipped && <span className="hash-tag-code">#DoneWith2020</span>}
          <p>{text}</p>
        </>
      )}
    </div>
  );
};

const getCards = (arr) => {
  let arrLength = arr.length;
  let newArr = [];
  for (let i = 0; i < 9; i++) {
    newArr.push(arr[i]);
  }
  return newArr;
};

const FlipView = ({ gameData, roomData }) => {
  const users = roomData.roomObj.users;
  let dw = _.get(gameData, "gameObj.screens.dw") || {};
  let goldCardText = _.get(dw, "gold_card_text") || [];
  let rigtCardText = _.get(dw, "response_card_text") || [];
  let status = _.get(roomData, "roomObj.game_state.status") || "";
  const defaultTrack = _.get(gameData, "gameObj.tabletop_default_sound") || "";
  const cardSound = _.get(gameData, "gameObj.tabletop_card_sound") || "";
  const [playedcard, setplayedcard] = useState([]);
  const [requiredCards, setRequiredCards] = useState([]);
  let totalPlayedCards = roomData.roomObj?.game_state.played_cards;
  const all_cards = getCards(totalPlayedCards);
  const allFlippedCards = [];
  const allOtherCards = [];
  all_cards &&
    all_cards.length > 0 &&
    all_cards.map((item) => {
      if (item !== undefined && item.flipped) {
        allFlippedCards.push(item);
      } else {
        allOtherCards.push(item);
      }
    });

  let finalArr = [1, ...all_cards];
  const play_user_audio_effect = (player_id) => {
    const player_details =  users.find(user => user.player_id === player_id)
    playAudio(player_details.audio_effect);
  }
  
  useEffect(() => {
    if(totalPlayedCards.length > 0){
      let newArr = requiredCards
      let new_user;
      if(totalPlayedCards.length === 1) {
        new_user = totalPlayedCards[0]
      } else {
        for(let card of totalPlayedCards) {
          let found = false
          for(let newCard of newArr) {
            if(newCard.player_id === card.player_id) {
              found = true
            }
          }
          if(!found) {
            new_user = card
          }
        }
      }
      play_user_audio_effect(new_user.player_id)
      setRequiredCards(totalPlayedCards)
    }
  }, [totalPlayedCards.length])

  useEffect(() => {
    if (
      status === "Joining" ||
      status === "PrePlay" ||
      status === "Playing" ||
      status === "Reading" ||
      status === "Evaluating"
    ) {
      playAudio(defaultTrack);
    }
  }, [status]);

  const playAudio = (url) => {
    var audio = document.createElement("audio");
    audio.src = url;
    audio.style.display = "none"; //added to fix ios issue
    audio.autoplay = true; //avoid the user has not interacted with your page issue
    audio.onended = function () {
      audio.remove(); //remove after playing to clean the Dom
    };
    document.body.appendChild(audio);
  };
  let cardText =
    rigtCardText &&
    rigtCardText.length > 0 &&
    rigtCardText.toString().replace(/,/g, "\n");

  return (
    <>
      <GlobalStyle />
      <div className="dw20-FlipView h-100">
        <div className="h-100 item-wrapper left">
          {roomData && roomData.roomObj && status === "PrePlay" && (
            <LeftCard goldCardText={goldCardText} status={status} />
          )}
          {roomData &&
            (status === "Playing" ||
              status === "Reading" ||
              status === "Evaluating") && (
              <LeftCard
                flipped
                text={roomData.roomObj?.game_state.prompt}
                status={status}
              />
            )}
        </div>
        <div className="h-100  item-wrapper right">
          <div className="right-card-wrapper">
            {(status === "Playing" ||
              status === "Reading" ||
              status === "Evaluating") && (
              <>
                {allFlippedCards.length > 0 ? (
                  <div className="w-100 games-card-content">
                    {finalArr &&
                      finalArr.length > 0 &&
                      finalArr.map((data, index) => {
                        if (index === 0) {
                          return <></>;
                        }
                        if (data === undefined) {
                          return <div key={index} className="isEmpty" />;
                        } else {
                          return (
                            <>
                              <RightCard
                                key={index}
                                normal
                                {...data}
                                flipped={data?.flipped}
                                text={
                                  data?.flipped ? data?.card?.text : cardText
                                }
                                que={roomData.roomObj?.game_state.prompt}
                                status={status}
                              />
                              {/* {status === "Reading" && data?.flipped && (
																	<FlipModal que={roomData.roomObj?.game_state.prompt.replace(/\[BLANK]/g, "________")} text={data?.card?.text} flipped={data?.flipped} />
																	// <div
																	//   className="dw20-game-modal"
																	//   centered
																	//   style={{
																	//     backgroundImage: `url(${background})`,
																	//   }}
																	// >
																	//   <div className="card-wrapper">
																	//     <div className="view-card card-left">
																	//       <span className="hash-tag-code">
																	//         #DoneWith2020
																	//       </span>
																	//       <p>
																	//         {roomData.roomObj?.game_state.prompt.replace(
																	//           /\[BLANK]/g,
																	//           "________"
																	//         )}
																	//       </p>
																	//     </div>
																	//     <img className="arrow" src={arrow} />
																	//     <div className="view-card card-right largeText">
																	//       <span className="hash-tag-code">
																	//         #DoneWith2020
																	//       </span>
																	//       <p>{data?.card?.text}</p>
																	//     </div>
																	//   </div>
																	// </div>
																)} */}
                            </>
                          );
                        }
                      })}
                  </div>
                ) : (
                  <>
                    <div className="w-100 games-card-content">
                      {all_cards &&
                        all_cards.length > 0 &&
                        all_cards.map((data, index) => {
                          if (data) {
                            return (
                              <>
                                <RightCard
                                  flipped={data?.flipped}
                                  text={
                                    data?.flipped ? data?.card?.text : cardText
                                  }
                                  que={roomData.roomObj?.game_state.prompt}
                                  status={status}
                                />
                              </>
                            );
                          } else {
                            return <div key={index} className="isEmpty" />;
                          }
                        })}
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FlipView;

const GlobalStyle = createGlobalStyle`
.dw20-content{
 
/*

  @media (max-height: 830px) {
    padding-top:0 !important;
    padding-bottom:0 !important;
  }
  @media (max-width:1439.98px) {
    padding-top:0 !important;
    padding-bottom:0 !important;
  }
  */
}
`;
